<style scoped lang="less">
  tbody {
    td {
      position: relative;
      height: 40px;
      border-left: 1px solid #e0e0e0;
      border-right: 1px solid #e0e0e0;
    }
  }
</style>
<template>
  <tr>
    <td v-for="column in columns">
      <timetable-cell :column="column" :row="row" @hover-active="onActive" :activeId="activeId" :types="types"/>
    </td>
  </tr>
</template>
<script>
  import TimetableCell from './TimetableCell.vue'
  export default {
    name: 'TimetableRow',
    components: {
      TimetableCell
    },
    props: {
      columns: {
        type: Array,
      },
      row: {
        type: Object,
      },
      types: {
        type: Array
      }
    },
    data () {
      return {
        activeId: -1
      }
    },
    computed: {
    },
    methods: {
      onActive (id) {
        this.activeId = id
      }
    },
    mounted () {
    },
    watch: {},
  }
</script>





// WEBPACK FOOTER //
// TimetableRow.vue?129fb334